export default "__VITE_ASSET__DcV5OW$Y__"